import { API } from '@base/core';
import { useQuery } from 'react-query';

export function useGetFormSubmissionHistory(campaignId: string, submissionId: string) {
  return useQuery(['campaigns', campaignId, 'submissions', submissionId, 'history'], async () => {
    return await API.campaigns.getFormSubmissionHistory(campaignId, submissionId);
  });
}
